export const autoConsentBanner = false
      
export const cookieBotId = "e3fb1ace-d415-4e33-9cfc-4bb5b1af8625"
      